import { Typography, Grid } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import Button from '../../components/Buttons/Button';

const Page404 = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <Grid
      container
      direction='column'
      alignItems='center'
      spacing={1}
      pt={20}
    >
      <Grid item>
        <Typography
          variant='h2'
          color='primary'
        >
          {intl.formatMessage({ id: 'thankYouForYourInterest' })}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant='h6'>{intl.formatMessage({ id: 'page404Message' })}</Typography>
      </Grid>
      <Grid item>
        <Typography
          variant='h6'
          paragraph
        >
          {intl.formatMessage({ id: 'checkAddressAndRetry' })}
        </Typography>
      </Grid>
      <Grid item>
        <Button
          type='submit'
          onClick={() => {
            navigate('/');
          }}
          label={intl.formatMessage({ id: 'backToHomepage' })}
        />
      </Grid>
    </Grid>
  );
};

export default Page404;
